// React
import { createContext, useState, useContext, useEffect } from 'react';

// Jwt
import { jwtDecode } from 'jwt-decode';

// Services
import { authService } from '../services/authService';

// ─── MOCK FLAG ───────────────────────────────────────────────────────────────
const USE_MOCK = false; // Mude para false para usar a API real

const MOCK_USERS = [
  { numUser: 'a1b2c3d4-e5f6-4789-abcd-000000000001', email: 'admin@mock.com', password: '123456' },
  { numUser: 'a1b2c3d4-e5f6-4789-abcd-000000000002', email: 'user@mock.com',  password: '123456' },
];

// Gera um JWT falso (não validado, só para decodificar)
const generateMockToken = (payload) => {
  const header  = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const body    = btoa(JSON.stringify(payload));
  return `${header}.${body}.mock-signature`;
};
// ─────────────────────────────────────────────────────────────────────────────

// 1. Cria o contexto
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userGuid, setUserGuid] = useState(null);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const decoded = jwtDecode(token);
    setUserGuid(decoded.numUser);
    setUserName(decoded.email);
  }, []); // lista de dependências

  const login = async (userEmail, userPassword) => {
    // ── MOCK ─────────────────────────────────────────────────────────────────
    if (USE_MOCK) {
      const mockUser = MOCK_USERS.find(
        (u) => u.email === userEmail && u.password === userPassword
      );
      if (!mockUser) throw new Error('Credenciais inválidas');
      const token = generateMockToken({ numUser: mockUser.numUser, email: mockUser.email });
      localStorage.setItem('token', token);
      setUserGuid(mockUser.numUser);
      setUserName(mockUser.email);
      return;
    }
    // ─────────────────────────────────────────────────────────────────────────
    const response = await authService.login(userEmail, userPassword);
    if (response) {
      const decoded = jwtDecode(response.token);
      setUserGuid(decoded.numUser);
      setUserName(decoded.name);
    } else {
      throw new Error('Erro ao fazer login');
    }
  };

  const logout = async () => {
    if (!USE_MOCK) await authService.logout();
    localStorage.removeItem('token');
    setUserGuid(null);
    setUserName(null);
  };

  const register = async (name, userEmail, userPassword) => {
    // ── MOCK ─────────────────────────────────────────────────────────────────
    if (USE_MOCK) {
      const generateGuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      const newGuid = generateGuid();
      MOCK_USERS.push({ numUser: newGuid, email: userEmail, password: userPassword });
      const token = generateMockToken({ numUser: newGuid, email: userEmail });
      localStorage.setItem('token', token);
      const decoded = jwtDecode(token);
      setUserGuid(decoded.numUser);
      setUserName(decoded.email);
      return;
    }
    // ─────────────────────────────────────────────────────────────────────────
    const response = await authService.register(name, userEmail, userPassword);
    if (response) {
      const decoded = jwtDecode(response.token);
      setUserGuid(decoded.numUser);
      setUserName(decoded.email);
    } else {
      throw new Error('Erro ao se registrar');
    }
  };

  return (
    <AuthContext.Provider value={{ userGuid, userName, login, logout, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);